import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import * as getters from "./getters";
import * as mutations from "./mutations";
import * as actions from "./actions";

// import registrationModule from './modules/registrationModule'
import forgotPassword from "./modules/account/forgotPassword";
import login from "./modules/account/login";
import registration from "./modules/account/registration";
import otp from "./modules/account/otp";
import customerSupport from "./modules/help/customerSupport";
import faq from "./modules/help/faq";
import details from "./modules/myprofile/details";
import kyc from "./modules/myprofile/kyc";
import contactUs from "./modules/contactUs";
import logout from "./modules/logout";
import manage from "./modules/mypacks/manage";
import renew from "./modules/mypacks/renew";
import addpacks from "./modules/addpacks/addPacks";
import cart from "./modules/cart";
import myIndigital from "./modules/myIndigital";
import channelList from "./modules/addpacks/channelList";
import channelListDetails from "./modules/planDetailImg";
import bannerImage from "./modules/bannerImg";
import payment from "./modules/payment";
import topup from "./modules/topUp";
import alert from "./modules/alert";
import transaction from "./modules/transaction";
import instantPayment from "./modules/instantPayment";
import ottquickpay from "./modules/ottQuickpay.js";

// let base_url = getBaseURL(window.location.origin)
export const store = new Vuex.Store({
  state: {
    name: "NXT Digital Selfcare Portal",
    version: "v1.0.5",
    mode: "production",
    server: "live",
    // baseUrl: "https://ccare.incablenet.net/",
    baseUrl: getBaseURL(window.location.origin),
    userInfo: undefined,
    docImage: undefined,
    getCartDetails: {},
    surveyQuestions: [],
    pageNum: 1,
    cartData: [],
    CTAImages: '',
    CartDetails: [],
    bbDetails: false
  },
  getters,
  mutations,
  actions,
  modules: {
    forgotPassword,
    login,
    registration,
    otp,
    faq,
    customerSupport,
    details,
    kyc,
    contactUs,
    logout,
    manage,
    renew,
    addpacks,
    cart,
    myIndigital,
    bannerImage,
    channelList,
    channelListDetails,
    payment,
    topup,
    alert,
    transaction,
    instantPayment,
    ottquickpay
  }
});
function getBaseURL (data) {
    if (data == 'http://localhost:8080') {
        return 'https://customercare.nxtdigital.in/'
        // return 'https://imclselfcaretest.mobiotics.com'
    }
    return data
}



// WEBPACK FOOTER //
// ./src/store/store.js